module.exports={cookies:"Cookies",help:"Help",privacy:"Privacy (UPDATED)",signInWithId:"Sign In with an Adobe ID",termsOfUse:"Terms of Use"};